(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-collection-banner"]) return;
  try {
    
  // Submitting on change keeps the control to a single interaction; the
  // <noscript> button covers the case where this never runs.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-dv-sort]');
    if (select) select.form?.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-community-videos"] && !Shopify.designMode) return;
  try {
    
  /*
    Owns which clip is live and whether the wall has sound. The first tile
    starts on its own once it scrolls into view; tapping any tile hands
    playback to it and pauses whatever was running. Visitors who ask for
    reduced motion get posters until they choose.

    Sound is one setting for the whole wall rather than per clip: a visitor who
    unmutes has said they want to hear these, so the next clip they open plays
    aloud too. It starts muted because no browser grants autoplay with sound.
  */
  const DV_VIDEO_VOLUME = 0.75;

  class DvVideoWall extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('[data-dv-video]'));
      if (!this.tiles.length) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.playing = reduced ? -1 : 0;
      this.soundOn = false;
      this.visible = new Set();
      this.dataset.sound = 'off';

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.visible.add(entry.target);
            else this.visible.delete(entry.target);
          });
          this.sync();
        },
        { threshold: 0.35 },
      );

      this.tiles.forEach((tile, index) => {
        const video = tile.querySelector('video');
        // Set as a property too — autoplay is rejected without it.
        video.muted = true;
        video.volume = DV_VIDEO_VOLUME;
        this.observer.observe(tile);

        tile.querySelector('[data-dv-play]').addEventListener('click', () => {
          this.playing = this.playing === index ? -1 : index;
          this.sync();
        });

        tile.querySelector('[data-dv-sound]').addEventListener('click', () => {
          this.soundOn = !this.soundOn;
          this.sync();
        });
      });

      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    sync() {
      this.dataset.sound = this.soundOn ? 'on' : 'off';

      this.tiles.forEach((tile, index) => {
        const video = tile.querySelector('video');
        const play = tile.querySelector('[data-dv-play]');
        const sound = tile.querySelector('[data-dv-sound]');
        const wanted = index === this.playing;

        if (wanted && this.visible.has(tile)) {
          video.muted = !this.soundOn;
          video.volume = DV_VIDEO_VOLUME;
          // A refused play leaves the clip silent rather than stuck: fall back
          // to muted, which browsers always allow.
          video.play().catch(() => {
            video.muted = true;
            this.soundOn = false;
            this.dataset.sound = 'off';
            video.play().catch(() => {});
          });
        } else {
          video.pause();
          // Whatever is not live is silent, so the clip that is running is the
          // only thing audible.
          video.muted = true;
        }

        tile.dataset.playing = String(wanted);
        play.setAttribute('aria-label', wanted ? play.dataset.labelPause : play.dataset.labelPlay);
        sound.setAttribute('aria-label', this.soundOn ? sound.dataset.labelMute : sound.dataset.labelUnmute);
      });
    }
  }

  if (!customElements.get('dv-video-wall')) customElements.define('dv-video-wall', DvVideoWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-header"]) return;
  try {
    
  /*
    Cycles the announcement bar when more than one message is configured. The
    first is already in the markup, so this only takes over from the second
    onwards and nothing moves for a single message.
  */
  function dvStartAnnouncements() {
    const el = document.querySelector('[data-dv-announce-rotate]');
    if (!el) return;

    const messages = el.dataset.dvAnnounceRotate.split('||').filter(Boolean);
    if (messages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let index = 0;
    setInterval(() => {
      index = (index + 1) % messages.length;
      el.textContent = messages[index];
    }, 3000);
  }

  document.addEventListener('DOMContentLoaded', dvStartAnnouncements);

  /*
    Opens and closes the search drop-down and the mobile category drawer. Both
    live inside the header element so a single listener set covers them.
  */
  class DvHeader extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-dv-search]');
      this.drawer = this.querySelector('[data-dv-drawer]');
      this.searchToggle = this.querySelector('[data-dv-search-open]');

      this.searchToggle?.addEventListener('click', () => this.toggleSearch());
      this.querySelector('[data-dv-search-close]')?.addEventListener('click', () => this.toggleSearch(false));
      this.querySelector('[data-dv-menu-open]')?.addEventListener('click', () => this.toggleDrawer(true));
      this.querySelectorAll('[data-dv-menu-close]').forEach((el) =>
        el.addEventListener('click', () => this.toggleDrawer(false)),
      );

      this.onKey = (event) => {
        if (event.key !== 'Escape') return;
        this.toggleSearch(false);
        this.toggleDrawer(false);
      };
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    toggleSearch(force) {
      if (!this.search) return;
      const open = force === undefined ? this.search.hidden : force;
      this.search.hidden = !open;
      this.searchToggle?.setAttribute('aria-expanded', String(open));
      if (open) {
        this.querySelector('[data-dv-search-field]')?.focus();
        this.bindSuggest();
      } else if (this.suggest) {
        this.suggest.hidden = true;
      }
    }

    /*
      Predictive results from Shopify's suggest endpoint. Bound lazily, on the
      first open, so a shopper who never searches pays nothing for it.
    */
    bindSuggest() {
      if (this.suggestBound) return;
      this.suggestBound = true;

      const field = this.querySelector('[data-dv-search-field]');
      this.suggest = this.querySelector('[data-dv-suggest]');
      if (!field || !this.suggest) return;

      let timer;
      let latest = 0;

      field.addEventListener('input', () => {
        clearTimeout(timer);
        const term = field.value.trim();
        if (term.length < 2) {
          this.suggest.hidden = true;
          return;
        }
        timer = setTimeout(async () => {
          const ticket = ++latest;
          const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5&section_id=dv-predictive-search`;
          try {
            const markup = await fetch(url).then((r) => r.text());
            // A slower earlier request must not overwrite a newer result.
            if (ticket !== latest) return;
            const parsed = new DOMParser().parseFromString(markup, 'text/html');
            const results = parsed.querySelector('[data-dv-suggest-results]');
            this.suggest.innerHTML = results ? results.innerHTML : '';
            this.suggest.hidden = !this.suggest.innerHTML.trim();
          } catch {
            this.suggest.hidden = true;
          }
        }, 200);
      });
    }

    toggleDrawer(open) {
      if (!this.drawer) return;
      this.drawer.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) this.querySelector('.dv-drawer__close')?.focus();
    }
  }

  if (!customElements.get('dv-header')) customElements.define('dv-header', DvHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
